import { useEffect, useState } from 'react';
import { useNavigateTo } from '../../v1/components/live/hooks/useNavigateTo.js';
import { getClosestDate } from '../../v1/components/live/utils.js';
import { Outlet, useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { getAllV2Gamefacts, getAllV2GamefactsStats } from '../../api/index.js';
import SearchFilterDTO from '../DTO/SearchFilterDTO.js';
import ClassementDTO from '../DTO/ClassementDTO.js';

const ClassementResolver = () => {
  
  const navigateTo = useNavigateTo();
  const { id } = useParams();

  const [liveClassement, setLiveClassement] = useState(null);

  useEffect(() => {

    setLiveClassement(new ClassementDTO());

    const filter = new SearchFilterDTO({
      live : { _id : [id] }
    })

    // On doit récupérer la liste des competitions du live
      const fetchData = async () => {
        try {
          const response = await getAllV2GamefactsStats(JSON.stringify(filter));
          const { data } = response

          setLiveClassement({entries : data});
          //setLiveDates(["2024-07-24","2024-07-25","2024-07-27","2024-07-28","2024-07-29","2024-07-30","2024-07-31","2024-08-01","2024-08-02","2024-08-03","2024-08-04"])
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchData();

  }, [])

  
  if (!liveClassement) {
    return <CircularProgress />
  }

  return <Outlet context={{liveClassement}}/>;
}

export default ClassementResolver